import React from "react";
import { Award } from "lucide-react";
import { PATENTS } from "../lib/content";

const Patents = () => (
  <section
    id="patents"
    data-testid="section-patents"
    className="relative py-16 sm:py-20 bg-ink text-alabaster overflow-hidden"
  >
    <div className="absolute inset-0 dot-grid opacity-[0.08] pointer-events-none" aria-hidden />
    <div
      className="absolute -top-40 -right-40 w-[480px] h-[480px] rounded-full pointer-events-none"
      style={{ background: "radial-gradient(circle, rgba(245,187,31,0.22), transparent 60%)" }}
      aria-hidden
    />

    <div className="relative max-w-7xl mx-auto px-6 sm:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-14 items-end">
        <div className="lg:col-span-7 reveal">
          <div className="eyebrow !text-terracotta-soft inline-flex items-center gap-3">
            <span className="block w-10 h-px bg-terracotta-soft" />
            Registered Patents
          </div>
          <h2
            data-testid="patents-heading"
            className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold text-alabaster leading-[1.05] tracking-tight"
          >
            Three patents. <br />
            <span className="text-terracotta-soft">One conviction.</span>
          </h2>
        </div>
        <div className="lg:col-span-5 reveal">
          <p className="text-alabaster/70 text-base sm:text-lg leading-relaxed">
            Tech should restore agency to the people it serves. My patents focus on the Deaf community, patient monitoring, and women's health — areas where dignity is the metric.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
        {PATENTS.map((pt, i) => (
          <article
            key={pt.no}
            data-testid={`patent-card-${i}`}
            className="reveal card-dark overflow-hidden group"
            style={{ transitionDelay: `${i * 90}ms`, background: "#1C201E", border: "1px solid #2A2F2C" }}
          >
            <div className="relative aspect-[4/3] overflow-hidden">
              <img
                src={pt.image}
                alt={pt.title}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute top-4 left-4 flex items-center gap-2 bg-terracotta text-alabaster px-3 py-1.5 rounded-full eyebrow !text-alabaster !text-[10px]">
                <Award size={12} /> Patent No. {pt.no}
              </div>
            </div>
            <div className="p-7">
              <div className="eyebrow !text-terracotta-soft">{pt.year}</div>
              <h3 className="font-display mt-3 text-2xl font-bold text-alabaster leading-snug">{pt.title}</h3>
              <p className="mt-4 text-sm text-alabaster/70 leading-relaxed">{pt.desc}</p>
              <div className="mt-6 pt-5 border-t border-alabaster/15 text-[12px] text-alabaster/60 leading-snug">
                {pt.issuer}
              </div>
            </div>
          </article>
        ))}
      </div>

      {/* More patents coming teaser */}
      <div className="reveal mt-10 relative overflow-hidden rounded-3xl border border-dashed border-terracotta/40 px-6 sm:px-10 py-7 flex flex-col sm:flex-row items-start sm:items-center gap-5 justify-between">
        <div
          className="absolute -top-24 -right-24 w-72 h-72 rounded-full pointer-events-none"
          style={{ background: "radial-gradient(circle, rgba(245,187,31,0.18), transparent 60%)" }}
          aria-hidden
        />
        <div className="relative flex items-center gap-5">
          <span className="relative inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-terracotta text-ink shrink-0">
            <span className="absolute inset-0 rounded-2xl bg-terracotta animate-ping opacity-30" aria-hidden />
            <Award size={22} strokeWidth={1.8} />
          </span>
          <div>
            <div className="eyebrow !text-terracotta-soft">In the Pipeline</div>
            <div className="font-display text-xl sm:text-2xl font-bold text-alabaster leading-tight mt-1">
              More patents are on the way.
            </div>
            <div className="text-sm text-alabaster/70 mt-1">
              New filings in AI-powered assistive and health tech — stay tuned.
            </div>
          </div>
        </div>
        <span className="relative inline-flex items-center gap-2 text-[11px] font-display font-bold uppercase tracking-widest text-terracotta border border-terracotta/40 rounded-full px-4 py-2">
          Filing Soon · 2026
        </span>
      </div>
    </div>
  </section>
);

export default Patents;
